export default async function adicionarUser(user) {
    const url = `${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/users`;
    console.log("Adicionando usuário:", user);
    try {
        const userSession = JSON.parse(sessionStorage.getItem("user"));

        if (!userSession || !userSession.token) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { token } = userSession;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(user),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(
                `Erro ao adicionar usuário: ${errorData.message || response.statusText}`
            );
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error("Erro ao adicionar usuário:", error.message);
        throw error;
    }
}
